module.exports = __webpack_public_path__ + "434a2a5c14785f5dde8bf393c80169ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-icons/gears.png
// module id = 2057
// module chunks = 1